import { app } from '../../app.module'
app
  // 一括タグ管理モーダル用のパネル
  .directive('batchTagCheckbox', () => {
    return {
      restrict: 'E',
      template: require('./batch-tag-checkbox.pug')(),
      scope: {
        targetId: '=',
        selectedIds: '=',
      },
      controller: function ($scope) {
        // 一括で処理できる上限を設ける
        const checkLimit = 50

        // 以前に選択済みのチェックボックスである場合は、チェックをつける
        $scope.selectedIds.forEach((element: number) => {
          if (element === $scope.targetId) {
            $scope.checkbox = true
            $scope.$emit('addCheck')
          }
        })

        // 選択解除ボタンが押された際に、チェックボックスのチェックを空にする
        $scope.$on('resetCheckBox', () => {
          $scope.checkbox = false
          $scope.$emit('removeCheck')
        })

        // 一括チェックボックスのチェックに変更が加えられた場合
        $scope.$on('changeCheck', (event: {}, status: boolean) => {
          // 一括チェックがOn / Offされた際に、同一の状態の場合は、処理を行わない
          if (status === true && $scope.checkbox === true) {
            return
          }
          if (status === false && $scope.checkbox === false) {
            return
          }
          if (status === true && $scope.selectedIds.length >= checkLimit) {
            return
          }
          check(status)
        })

        /**
         * チェックボックスにチェックをつけた際の処理
         * @param  {boolean} チェックをつけた場合はtrue, 外した場合はfalse
         */
        $scope.check = function (status: boolean) {
          // タグが50個以上選択されていた場合は、以降の処理を行わない
          if (status === true && $scope.selectedIds.length >= checkLimit) {
            alert('50項目以上、同時に選択することはできません。')
            $scope.checkbox = false
            return
          }
          check(status)
        }

        /**
         * チェックをつけた場合はaddTargetIdを、 外した場合はremoveTargetIdを送信する
         * @param  {boolean} チェックをつけた場合はtrue, 外した場合はfalse
         */
        function check(checkbox: boolean) {
          if (checkbox === true) {
            $scope.checkbox = true
            $scope.$emit('addTargetId', $scope.targetId)
            $scope.$emit('addCheck')
          } else if (checkbox === false) {
            $scope.checkbox = false
            $scope.$emit('removeTargetId', $scope.targetId)
            $scope.$emit('removeCheck')
          }
        }
      },
    }
  })
